export default __webpack_public_path__ + "static/media/Upmarket_White_Logo.4dd83670.png";